(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JoiSchemaTable", [], factory);
	else if(typeof exports === 'object')
		exports["JoiSchemaTable"] = factory();
	else
		root["JoiSchemaTable"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition